import { render, staticRenderFns } from "./CreateOrUpdate.vue?vue&type=template&id=03c779d0&scoped=true"
import script from "./CreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c779d0",
  null
  
)

export default component.exports